import { Card, CardBody, Col, Media } from "reactstrap";
import { Btn, H4, Image, P } from "../../../../AbstractElements";
import { BookmarkFilter, Href } from "../../../../Constants/Constants";
import { useAppDispatch, useAppSelector } from "../../../../ReduxToolkit/Hooks";
import { setBookmarkFilter } from "../../../../ReduxToolkit/Reducers/BookmarkTabSlice";
import { dynamicImage } from "../../../../Utils";
import NavTab from "./NavTab";

const SideBar = () => {
  const { bookmarkFilter } = useAppSelector((state) => state.bookmarkTab);
  const dispatch = useAppDispatch();

  return (
    <Col xl="3" className="box-col-6">
      <div className="md-sidebar">
        <Btn tag="a" color="primary" className="md-sidebar-toggle" href={Href} onClick={() => dispatch(setBookmarkFilter())}>{BookmarkFilter}</Btn>
        <div className={`md-sidebar-aside job-left-aside custom-scrollbar ${bookmarkFilter ? "open" : ""}`}>
          <div className="email-left-aside">
            <Card>
              <CardBody>
                <div className="email-app-sidebar left-bookmark">
                  <Media className="d-flex">
                    <div className="media-size-email">
                      <Image className="me-3 rounded-circle" src={dynamicImage(`user/user.png`)} alt="user" />
                    </div>
                    <Media body className="flex-grow-1">
                      <H4>MARK JENCO</H4>
                      <P>Markjecno@gmail.com</P>
                    </Media>
                  </Media>
                  <NavTab />
                </div>
              </CardBody>
            </Card>
          </div>
        </div>
      </div>
    </Col>
  );
};

export default SideBar;
